<template>
	<b-card-body>
		<UpdateSchedule v-if="showModalType === 'manage-schedule'"/>
		<UpdateLocationData v-if="showModalType === 'update-location-data'"/>
		<UpdateHolidayData v-if="showModalType === 'update-holiday-data'"/>
		<CreateHoliday v-if="showModalType === 'create-holiday'"/>
	</b-card-body>
</template>

<script>
import UpdateSchedule from './updateSchedule'
import UpdateLocationData from './updateLocationData'
import UpdateHolidayData from './updateHolidayData.vue'
import CreateHoliday from './createHoliday.vue'
import {
	BCardBody,
    BFormSelect,
    BFormGroup
} from 'bootstrap-vue'

import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
	components: {
		BCardBody,
        BFormSelect,
		VueElementLoading,
        BFormGroup,
		UpdateSchedule,
		UpdateLocationData,
		UpdateHolidayData,
		CreateHoliday
	},
	computed: {
		...mapState('locations', ['showModalType'])
	}
}
</script>